import SectionHeading from '@/pages/home/components/SectionHeading';
import useScrollReveal from '@/hooks/useScrollReveal';
import { homeVerifySteps } from '@/mocks/home';

export default function VerifyGuide() {
  const { ref, visible } = useScrollReveal();

  return (
    <section id="verify" className="w-full bg-secondary-900 py-16 md:py-24 scroll-mt-24">
      <div ref={ref} className={`w-full px-4 md:px-8 nh-reveal ${visible ? 'nh-in' : ''}`}>
        <SectionHeading
          tone="dark"
          kicker="核验说明"
          title="从素材到实锤，中间隔着四步核验"
          desc="归档不是把截图堆在一起，而是给每条素材建立可回溯的链路。完成以下四步的条目，才会被标注为已核验实锤。"
        />

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {homeVerifySteps.map((step) => (
            <div key={step.id} className="flex flex-col rounded-lg bg-secondary-800 border border-secondary-700 p-6">
              <span className="font-heading text-3xl font-black text-accent-400">{step.index}</span>
              <h3 className="mt-4 font-heading text-lg font-bold text-background-50">{step.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-secondary-200">{step.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-4 rounded-lg bg-secondary-800 border border-secondary-700 px-6 py-5">
          <p className="text-sm text-secondary-200 text-center sm:text-left">
            核验结论以公开通报与可回溯来源为准，存疑条目会保留「待复核」状态，不会直接下结论。
          </p>
          <a
            href="#archive"
            className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-accent-500 text-foreground-950 text-sm font-medium whitespace-nowrap hover:bg-accent-400 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-right-up-line"></i>
            去归档里查验
          </a>
        </div>
      </div>
    </section>
  );
}